import { useEffect, useRef, useState } from "react";
import Globe from "react-globe.gl";
import { MARKETS } from "@/data/content";

// Lightweight, non-interactive globe for the Home page "Global Reach" teaser.
// Pointer events are disabled so the entire visual behaves as a single
// hyperlink (handled by the parent <Link>). Uses teal/mint brand dots.
const HomeGlobe = () => {
  const globeRef = useRef(null);
  const wrapRef = useRef(null);
  const [dims, setDims] = useState({ w: 520, h: 460 });

  useEffect(() => {
    const measure = () => {
      if (!wrapRef.current) return;
      const w = wrapRef.current.clientWidth;
      const h = Math.max(340, Math.min(560, Math.round(w * 0.82)));
      setDims({ w, h });
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  useEffect(() => {
    if (!globeRef.current) return;
    const controls = globeRef.current.controls();
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.6;
    controls.enableZoom = false;
    controls.enablePan = false;
    controls.enableRotate = false;
    globeRef.current.pointOfView({ lat: 18, lng: 40, altitude: 2.6 }, 0);
  }, []);

  const points = MARKETS.flatMap((m) =>
    m.pins.map((p) => ({ lat: p.lat, lng: p.lng, tier: m.tier }))
  );

  return (
    <div
      ref={wrapRef}
      className="pointer-events-none flex w-full select-none items-center justify-center"
    >
      <Globe
        ref={globeRef}
        width={dims.w}
        height={dims.h}
        backgroundColor="rgba(0,0,0,0)"
        globeImageUrl="https://unpkg.com/three-globe/example/img/earth-dark.jpg"
        bumpImageUrl="https://unpkg.com/three-globe/example/img/earth-topology.png"
        showAtmosphere={true}
        atmosphereColor="#3ABBB0"
        atmosphereAltitude={0.22}
        pointsData={points}
        pointLat="lat"
        pointLng="lng"
        pointAltitude={0.012}
        pointRadius={(d) => (d.tier === "expansion" ? 0.42 : 0.52)}
        pointColor={(d) => (d.tier === "expansion" ? "#41E19A" : "#3ABBB0")}
      />
    </div>
  );
};

export default HomeGlobe;
